import React from 'react'
import {NavbarLogoOnly} from '../../components/Properties/Navbar/Navbar'
import QRISPayment from '../../components/Payment/QRISPayment'

function QRIS() {
    return (
        <div className="container body-content mobile-view">
            <NavbarLogoOnly link="/"/>
            <QRISPayment/>
        </div>
    )
}

export default QRIS 
